module.exports = __webpack_public_path__ + "img/yakor.005e0105.svg";